// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class NamedRef {
  readonly id: string;
  readonly name: string;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
  }

  static zero(): NamedRef {
    const zeroValues: ExcludeMethodsDeep<NamedRef> = {
      id: NIL_UUID,
      name: '',
    };
    return new NamedRef(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type NamedRefWireFormat = {
  id: string;
  name: string;
};

type NewNamedRefProps = PartialDeep<NamedRef, { recurseIntoArrays: true }>;
export const NewNamedRef: (props: NewNamedRefProps) => NamedRef = (props) => new NamedRef(props);

type NewNamedRefFromWireFormatProps = PartialDeep<NamedRefWireFormat, { recurseIntoArrays: true }>;
export const NewNamedRefFromWireFormat: (props: NewNamedRefFromWireFormatProps) => NamedRef = (
  props,
) => new NamedRef(props);
